import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";

class ManageGameProduct extends React.Component {
    handleSubmit(e) {
        e.preventDefault();

        const body = {
            'price': e.target.price.value,
            'currency': e.target.currency.value,
        };

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/product', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));
            window.location.reload(false);
        });
    }

    render() {
        if (this.props.companyIsFullType) {
            return (
                <div>
                    <h1>Product information</h1>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <label>Price: </label>
                        <input readOnly={this.props.settings ? !this.props.settings.is_paid_apps_allowed : true} class="form-control" type="number" name="price"
                               defaultValue={this.props.game.paid_product ? (this.props.game.paid_product.new_price >= 0 ? this.props.game.paid_product.new_price : this.props.game.paid_product.price) : 0}/>
                        <br/>
                        {(this.props.settings ? this.props.settings.is_paid_apps_allowed : false) ?
                            <div><label>Currency: </label>
                                <input class="form-control" type="text" name="currency"
                                       defaultValue={this.props.game.paid_product ? this.props.game.paid_product.currency : 'USD'}/>
                                <br/>
                            </div>
                            : <br/>
                        }

                        <input class="btn btn-success" type="submit" value="Save"/>
                    </form>
                </div>
            );
        } else {
            return <h1>Available only for paid company</h1>;
        }
    }
}

export default withRouter(ManageGameProduct);
